module.exports = __webpack_public_path__ + "static/icon-diya.1c2dc7a9.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon-diya.png
// module id = 309
// module chunks = 2